// extracted by mini-css-extract-plugin
export default {"btnWrapper":"AddUserButton_btnWrapper__UIs5p"};